var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_15_165"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 0,
    width: 22,
    height: 22,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,44,0)",
    clipPath: "url(#master_svg0_15_165)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.6382060546875,2.26793826171875L30.9093360546875,10.99741826171875L39.6362060546875,19.72431826171875L37.3670060546875,21.99421826171875L28.6394760546875,13.26661826171875L28.6368860546875,13.26991826171875L26.3670279046875,11.00001826171875L26.3702622346875,10.99741826171875L26.3612060546875,10.98841826171875L28.6304260546875,8.71850826171875L28.6394760546875,8.72755826171875L37.3690060546875,-0.00128173828125L39.6382060546875,2.26793826171875Z",
    fill: "#C1C1C1",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXia);
export default __webpack_public_path__ + "static/media/xia.368fbb59a93db10ef85721b1590b5438.svg";
export { ForwardRef as ReactComponent };